import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../../store/CoreStore';
import { usePopupSlice } from '../../../store/slices/popup/selectors';
import { popupActions } from '../../../store/slices/popup/slice';
import { Button, ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../../popup/types';

import { BlockingModalContent } from './BlockingModalContent';

export const ErrorConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const currentPopupData = usePopupSlice.currentPopupData();
  let code: string = '';
  if (currentPopupData !== null) {
    code = currentPopupData.code as string;
  }

  const action = [
    <Button
      key="OK"
      tk="OK"
      variant={ButtonVariant.ACCENT}
      onClick={() => {
        dispatch(popupActions.dismissPopup(PopupType.Error));
      }}
    />,
  ];

  return (
    <BlockingModalContent actions={action}>
      <L10nText tk={`ERROR_${code}`} />
    </BlockingModalContent>
  );
};
